module.exports = __webpack_public_path__ + "static/olajide-bfd9e181a5c8a2d11c2449d69a3e33b5.png";